// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header[data-v-466d4cdc]{z-index:31}@media (min-width:768px){.page-header .btn-wrap.translate-x-custom[data-v-466d4cdc]{transform:translateX(149px)}.page-header .btn-wrap.translate-x-custom-with-padding[data-v-466d4cdc]{transform:translateX(calc(100% + 20px))}}.page-header .btn-opaque.btn-icon[data-v-466d4cdc]{height:2.5rem;width:2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
